import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Theme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { makeStyles } from 'tss-react/mui';
import { theme } from 'styles/global-styles';
import { getPlacementFlagTypes } from '../helper';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: 0,
  },
  colorDot: {
    width: 16,
    height: 16,
    borderRadius: '50%',
  },
  colorTag: {
    minWidth: 42,
    paddingLeft: 5,
  },
  tagItem: {
    padding: '10px 0px 11px 9px',
  },
  checkIcon: {
    color: theme.palette.framework.system.navyBlue,
    marginRight: 12,
  },
  clearTag: {
    borderTop: `1px solid ${theme.palette.framework.system.silver}`,
    margin: '67px 20px 0px 0px',
    paddingBottom: 0,
    '&:hover': {
      backgroundColor: theme.palette.framework.system.white,
    },
  },
  clearText: {
    marginBottom: 0,
  },
}));

export interface TagOption {
  value: number;
  name: string;
}

interface IPersonalTags {
  onTagSelect: (tagId: number) => void;
  selecetedTagId?: number;
}

const PersonalTags: React.FC<IPersonalTags> = props => {
  const { onTagSelect, selecetedTagId } = props;
  const [options, setOptions] = React.useState<TagOption[]>([]);
  const [selectedIndex, setSelectedIndex] = React.useState<number>(selecetedTagId ?? null);
  const { classes } = useStyles();
  const { t } = useTranslation();

  const handleListItemClick = (id: number) => {
    if (selectedIndex === id) {
      setSelectedIndex(null);
      onTagSelect(null);
    } else {
      setSelectedIndex(id);
      onTagSelect(id);
    }
  };

  React.useEffect(() => {
    getPlacementFlagTypes(setOptions);
  }, []);

  return (
    <List className={classes.root}>
      {options?.map((color, index) => (
        <ListItem
          key={index}
          button
          onClick={() => handleListItemClick(color.value)}
          className={classes.tagItem}
          sx={{
            backgroundColor: selectedIndex === color.value ? theme.palette.framework.system.smoke : 'inherit',
          }}
        >
          <ListItemIcon className={classes.colorTag}>
            <Box
              sx={{
                backgroundColor: color.name,
              }}
              className={classes.colorDot}
            />
          </ListItemIcon>
          <ListItemText primary={color.name} />
          {selectedIndex === color.value && <CheckIcon className={classes.checkIcon} />}
        </ListItem>
      ))}
      <ListItemButton className={classes.clearTag} onClick={() => handleListItemClick(selectedIndex)}>
        <ListItemText
          primary={t('placement.profile.header.clearColorTag')}
          className={classes.clearText}
        ></ListItemText>
      </ListItemButton>
    </List>
  );
};

export default PersonalTags;
